import { useEffect } from "react";

const BASE = "InRange Agents";

// Set the browser tab title to "<context> - InRange Agents" so open tabs are
// distinguishable and the distinguishing context leads (e.g. "Amazon MAN4 -
// InRange Agents"). Pass the page / entity name; pass null/undefined (e.g. while
// it's still loading) to show just the base title. Restores the base title on
// unmount so a stale name can't linger when navigating to a page that doesn't
// set one.
export const useDocumentTitle = (context: string | null | undefined): void => {
  useEffect(() => {
    document.title = context ? `${context} - ${BASE}` : BASE;
    return () => {
      document.title = BASE;
    };
  }, [context]);
};
